'use client'

import { useEffect, useRef } from 'react'
import Script from 'next/script'
import useTheme from '@/hooks/useTheme'

declare global {
    interface Window {
        twttr: any
    }
}

const TwitterEmbed = ({ className, data }: { className: string, data: any }) => {
    const embedRef = useRef<HTMLDivElement>(null)
    const { theme } = useTheme()

    useEffect(() => {
        if (embedRef.current) {
            // Modify the theme within the blockquote tag
            const modifiedHtml = data.html.replace(
                /<blockquote([^>]*)class="twitter-tweet"/i,
                `<blockquote$1class="twitter-tweet" data-theme="${theme}"`
            )
            embedRef.current.innerHTML = modifiedHtml

            if (window?.twttr) {
                window.twttr.widgets.load(embedRef.current)
            }
        }
    }, [theme, embedRef.current])

    return (
        <>
            <meta name="twitter:widgets:theme" content={theme} />
            <meta name="twitter:widgets:border-color" content="#55acee" />
            <div className={className} ref={embedRef} />
            <Script src="https://platform.twitter.com/widgets.js" strategy='lazyOnload' />
        </>
    )
}

export default TwitterEmbed
